import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { jobs as staticJobs } from "../data/jobs";
import { services as staticServices } from "../data/services";
import { industries as staticIndustries } from "../data/industries";
import { fetchContent } from "../lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [jobs, setJobs] = useState(staticJobs);
  const [services, setServices] = useState(staticServices);
  const [industries, setIndustries] = useState(staticIndustries);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [j, s, i] = await Promise.all([
        fetchContent("jobs").catch(() => []),
        fetchContent("services").catch(() => []),
        fetchContent("industries").catch(() => []),
      ]);
      if (Array.isArray(j) && j.length) setJobs(j);
      if (Array.isArray(s) && s.length) setServices(s);
      if (Array.isArray(i) && i.length) setIndustries(i);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const value = {
    jobs,
    services,
    industries,
    loading,
    getJob: (slug) => jobs.find((x) => x.slug === slug),
    getService: (slug) => services.find((x) => x.slug === slug),
    getIndustry: (slug) => industries.find((x) => x.slug === slug),
    refresh: load,
  };

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  return ctx;
}
